/* Ondine quick add — AJAX add to cart with Dawn cart-drawer refresh + variant chooser modal */
(function () {
  if (window.__ondQuickAdd) return;
  window.__ondQuickAdd = true;

  /* ---------- shared: add a variant, refresh drawer ---------- */
  function refreshFromSections(sections) {
    var drawerEl = document.querySelector('cart-drawer');
    if (!sections) return;
    if (sections['cart-icon-bubble']) {
      var bub = document.getElementById('cart-icon-bubble');
      if (bub) {
        var nb = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var inner = nb.querySelector('.shopify-section');
        bub.innerHTML = inner ? inner.innerHTML : nb.body.innerHTML;
      }
    }
    if (drawerEl && sections['cart-drawer']) {
      var nd = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var newInner = nd.getElementById('CartDrawer');
      var cur = document.getElementById('CartDrawer');
      if (cur && newInner) cur.innerHTML = newInner.innerHTML;
      drawerEl.classList.remove('is-empty');
      setTimeout(function () {
        if (typeof drawerEl.open === 'function') drawerEl.open();
        else drawerEl.classList.add('animate', 'active');
      }, 250);
    }
  }

  function addToCart(vid) {
    var fd = new FormData();
    fd.append('id', vid);
    fd.append('quantity', '1');
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    var addUrl = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js';
    /* during the domain transition, section rendering only responds with _fd=0 on the myshopify domain */
    if (location.hostname.indexOf('.myshopify.com') !== -1) addUrl += '?_fd=0';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: fd
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) throw new Error(res.description || 'error');
      try { refreshFromSections(res.sections); } catch (err) { /* item added regardless */ }
      return res;
    });
  }

  /* ---------- direct quick add (single variant / upsells) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ond-card__qa[data-vid]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;

    var originalText = btn.textContent;
    btn.classList.add('is-loading');
    addToCart(btn.getAttribute('data-vid'))
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        btn.textContent = btn.getAttribute('data-added-label') || 'Added ✓';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = originalText; }, 2200);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        btn.textContent = 'Sold out';
        setTimeout(function () { btn.textContent = originalText; }, 2000);
      });
  });

  /* ---------- variant chooser modal ---------- */
  var money = (function () {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try {
      var fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur });
      return function (cents) { return fmt.format(cents / 100); };
    } catch (e) {
      return function (cents) { return '$' + (cents / 100).toFixed(2); };
    }
  })();

  var modal = null;

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('ondqa-lock');
    var m = modal;
    setTimeout(function () { if (m && m.parentNode) m.parentNode.removeChild(m); }, 220);
    modal = null;
  }

  function openModal(product, url) {
    closeModal();
    var sel = {};
    var first = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { first = product.variants[i]; break; }
    }
    if (!first) first = product.variants[0];
    product.options.forEach(function (opt, i) { sel[i] = first['option' + (i + 1)]; });

    function currentVariant() {
      return product.variants.find(function (v) {
        return product.options.every(function (_, i) { return v['option' + (i + 1)] === sel[i]; });
      }) || null;
    }

    function valueAvailable(optIndex, value) {
      return product.variants.some(function (v) {
        if (!v.available) return false;
        if (v['option' + (optIndex + 1)] !== value) return false;
        return product.options.every(function (_, i) {
          if (i === optIndex) return true;
          return v['option' + (i + 1)] === sel[i];
        });
      });
    }

    modal = document.createElement('div');
    modal.className = 'ondqa';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.innerHTML =
      '<div class="ondqa__backdrop"></div>' +
      '<div class="ondqa__panel">' +
        '<button type="button" class="ondqa__close" aria-label="Close"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 5l14 14M19 5L5 19"/></svg></button>' +
        '<div class="ondqa__head">' +
          (product.featured_image ? '<img class="ondqa__img" src="' + product.featured_image + '&width=180" onerror="this.style.display=\'none\'" alt="">' : '') +
          '<div class="ondqa__headtxt">' +
            '<div class="ondqa__title">' + product.title + '</div>' +
            '<div class="ondqa__price"></div>' +
          '</div>' +
        '</div>' +
        '<div class="ondqa__opts"></div>' +
        '<button type="button" class="ondqa__addbtn">Add to cart</button>' +
        '<a class="ondqa__full" href="' + url + '">View full details</a>' +
      '</div>';
    document.body.appendChild(modal);
    document.documentElement.classList.add('ondqa-lock');

    var opts = modal.querySelector('.ondqa__opts');
    var priceEl = modal.querySelector('.ondqa__price');
    var addBtn = modal.querySelector('.ondqa__addbtn');

    function render() {
      opts.innerHTML = '';
      product.options.forEach(function (opt, i) {
        var g = document.createElement('div');
        g.className = 'ondqa__group';
        var lab = document.createElement('div');
        lab.className = 'ondqa__label';
        lab.innerHTML = opt.name + ' <span>' + sel[i] + '</span>';
        g.appendChild(lab);
        var pills = document.createElement('div');
        pills.className = 'ondqa__pills';
        opt.values.forEach(function (val) {
          var p = document.createElement('button');
          p.type = 'button';
          p.className = 'ondqa__pill' + (sel[i] === val ? ' is-selected' : '') + (valueAvailable(i, val) ? '' : ' is-muted');
          p.textContent = val;
          p.addEventListener('click', function () { sel[i] = val; render(); });
          pills.appendChild(p);
        });
        g.appendChild(pills);
        opts.appendChild(g);
      });
      var v = currentVariant();
      if (v) {
        var html = '<strong>' + money(v.price) + '</strong>';
        if (v.compare_at_price && v.compare_at_price > v.price) html += ' <s>' + money(v.compare_at_price) + '</s>';
        priceEl.innerHTML = html;
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        addBtn.setAttribute('data-vid', v.id);
      } else {
        priceEl.innerHTML = '';
        addBtn.disabled = true;
        addBtn.textContent = 'Unavailable';
      }
    }
    render();

    void modal.offsetHeight; /* force reflow so the transition runs */
    var m = modal;
    setTimeout(function () { m.classList.add('is-open'); }, 20);
    modal.querySelector('.ondqa__backdrop').addEventListener('click', closeModal);
    modal.querySelector('.ondqa__close').addEventListener('click', closeModal);
    addBtn.addEventListener('click', function () {
      if (addBtn.disabled || addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading');
      addBtn.textContent = 'Adding…';
      addToCart(addBtn.getAttribute('data-vid'))
        .then(function () { closeModal(); })
        .catch(function () {
          addBtn.classList.remove('is-loading');
          addBtn.textContent = 'Sold out';
        });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.ond-card__qa--choose');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.classList.contains('is-loading')) return;
    var handle = btn.getAttribute('data-handle');
    var url = btn.getAttribute('data-url') || '/products/' + handle;
    var originalText = btn.textContent;
    btn.classList.add('is-loading');
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('http'); return r.json(); })
      .then(function (product) {
        btn.classList.remove('is-loading');
        btn.textContent = originalText;
        openModal(product, url);
      })
      .catch(function () {
        /* graceful fallback: go to the product page */
        window.location.href = url;
      });
  });
})();
